import { UI } from './UI';
import { appConfig as $config } from '../app.config';

export const ExportTo = (function () {
  let pdf = ({
    selector = false,
    cssfiles = [],
    css = '',
    filename = 'xxx',
    iframeurl = false,
    orientation = 'portret'
  } = {}) => {
    UI.blockPage();

    let html;

    if (iframeurl) {
      let iframe = $(
        `<iframe src="${iframeurl}" sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin" style="position:absolute;top:-10000px"/>`
      );
      $(window).on('message', (e) => {
        let data = e.originalEvent.data;
        if (data.pageloaded) {
          html = iframe.contents().find('html').clone();
          iframe.remove();
          pdfExport(html, selector, cssfiles, css, data.fileName, orientation);
          $(window).off('message');
        }
      });

      $('body').append(iframe);
    } else {
      html = $('html').clone();

      pdfExport(html, selector, cssfiles, css, filename, orientation);
    }
  };

  let pdfExport = (html, selector, cssfiles, css, filename, orientation) => {
    html = buildHTML(html, css, cssfiles);

    if (selector) {
      html = buldSelector(selector, html);
    }

    sendHTML(html, filename, orientation);
  };

  let buildHTML = (html, css, cssfiles) => {
    let base = $config.productionUrl;

    $('.kt-aside', html).remove();
    $('#kt_aside_close_btn', html).remove();
    $('#kt_header', html).remove();
    $('#kt_header_mobile', html).remove();

    $('head', html).prepend(`<base href="${base}">`);
    $('head', html).append(`<link href="/css/pdf/bootstrap-ie8.min.css" rel="stylesheet" type="text/css" />`);

    $('head', html).append(`<style type="text/css">#kt_wrapper{padding:0 !important}${css}</style>`);

    cssfiles.forEach((css) => {
      $('head', html).append(`<link href="${css}" rel="stylesheet" type="text/css" />`);
    });

    return html;
  };

  let buldSelector = (selector, html) => {
    let $p = $(selector, html);
    while (!$p.is('body')) {
      $p.addClass('js-print');
      $p = $p.parent();
    }
    $('body *:not(.js-print)', html).each(function () {
      if (!$(this).closest(selector).length && !$(this).is('script')) {
        $(this).remove();
      }
    });
    return html;
  };

  let sendHTML = (html, filename, orientation) => {
    let sendData = `<html lang="en">${html.html()}</html>`;
    let xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function () {
      let a = document.createElement('a');
      a.href = window.URL.createObjectURL(xhr.response); // xhr.response is a blob
      //a.download = `f4ntec_approval_mockup_${filename}_${moment().format('MM_DD_YYYY_HH:mm')}.pdf`; // Set the file name.
      a.download = `${filename}.pdf`; // Set the file name.
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      a.parentNode.removeChild(a);
      UI.unblockPage();
    };
    xhr.open('POST', $config.apiURL + 'prelistings/topdf?PaperSize=A4&Orientation=' + orientation);
    xhr.send(sendData);
  };

  return {
    pdf
  };
})();
